<template>
  <div>
    <div class="query-select">
      <el-form
        ref="queryForm"
        :model="queryForm"
        :inline="true"
        class="user-search"
      >
        <el-form-item label="试卷名称：">
          <el-input
            size="small"
            v-model="queryForm.name"
            placeholder="输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="等级：">
          <el-select
            size="small"
            @change="getTableInfo"
            clearable
            v-model="queryForm.courseLevel"
            placeholder="请选择难度等级"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in examLevel"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期：" class="mr-left">
          <el-date-picker
            @change="getTableInfo"
            clearable
            size="small"
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          size="small"
          round
          @click="getTableInfo"
          >查询</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-refresh-left"
          plain
          size="small"
          round
          @click="review"
          >重置</el-button
        >
        <el-button
          type="success"
          icon="el-icon-plus"
          plain
          size="small"
          round
          @click="openForm('create')"
          >新增</el-button
        >
      </div>
    </div>
    <div class="main-table">
      <el-table
        :data="tableData"
        style="width: 85vw"
        border
        stripe
        size="small"
        v-loading="loading"
        header-cell-class-name="table-header"
      >
        <el-table-column align="center" type="index" width="50">
        </el-table-column>
        <el-table-column align="center" prop="name" label="试卷名称">
        </el-table-column>
        <el-table-column align="center" prop="courseLevel" label="等级">
          <template slot-scope="scope">
            {{ getExamLabel(scope.row.courseLevel) }}
          </template>
        </el-table-column>

        <el-table-column align="center" prop="score" label="试卷分数">
          <template slot-scope="scope">
            {{ scope.row.score || 0 }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建日期">
        </el-table-column>
        <el-table-column align="center" prop="publish" label="上架状态">
          <template slot-scope="scope">
            <el-switch
              @change="publishChange(scope.row)"
              v-model="scope.row.publish"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="400">
          <template slot-scope="scope">
            <!-- <el-button
              plain
              size="mini"
              round
              type="success"
              @click="recycleClick(scope.row.id)"
              >恢复</el-button
            >
            <el-button
              type="danger"
              plain
              size="mini"
              round
              @click="removeClick(scope.row.id)"
              >删除</el-button
            > -->
            <el-button
              plain
              size="mini"
              round
              type="primary"
              @click="handleClick(scope.row)"
              >查看</el-button
            >
            <el-button
              plain
              size="mini"
              round
              type="warning"
              @click="openForm('edit', scope.row.questionPaperId)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              plain
              size="mini"
              round
              @click="removeClick(scope.row.questionPaperId)"
              >删除</el-button
            >
            <el-button
              plain
              size="mini"
              round
              @click="contact(scope.row)"
              v-if="scope.row.isGeneratePaper != 1"
              >关联试题</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="10"
        layout="total, prev, pager, next"
        :current-page.async="queryForm.pageNum"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <DialogForm ref="dialogFormRef" @success="getTableInfo"></DialogForm>
    <!-- 关联试题弹框 -->
    <QuestionDialog
      ref="questionDialogRef"
      @success="getTableInfo"
      @bucketOpen="openBucket"
    />
    <!-- 试题篮 -->
    <BucketDialog
      ref="bucketDialogRef"
      @success="bucketSave"
      @clearBucket="clearBucket"
      @openScore="openScore"
    />
    <ScoreDialog
      ref="scoreDialogRef"
      @success="getTableInfo"
      @setScore="setScore"
    />
  </div>
</template>
<script>
import { getList, deleteInfo, editInfo } from "@/api/handsOnPaper.js";
import DialogForm from "./DialogForm.vue";
import { tansParams } from "@/utils/util";
import { getExamLabel, examLevel } from "@/utils/dict.js";
import QuestionDialog from "./QuestionDialog.vue";
import BucketDialog from "./BucketDialog.vue";
import ScoreDialog from "./ScoreDialog.vue";
export default {
  components: {
    DialogForm,
    ScoreDialog,
    QuestionDialog,
    BucketDialog
  },
  data() {
    return {
      examLevel,
      loading: false,
      //   搜索栏
      queryForm: {
        pageNum: 1,
        courseLevel: "",
        pageSize: 10
      },
      tableData: [],
      dateRange: [],
      totalCount: 100
    };
  },
  methods: {
    getExamLabel,
    review() {
      this.queryForm = {
        pageNum: this.queryForm.pageNum,
        pageSize: 10,
        name: "",
        courseLevel: ""
      };

      this.dateRange = [];
      this.getTableInfo();
    },
    async publishChange(row) {
      if (!row.score || row.score == 0) {
        this.$message({
          type: "warn",
          message: "试卷分数为0，无法发布"
        });
        row.publish = row.publish == 1 ? 0 : 1;
        return;
      }
      const text = row.publish == 1 ? "发布" : "下架";
      await this.$confirm(`确定${text}此试卷?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const params = {
            questionPaperId: row.questionPaperId,
            publish: row.publish
          };
          const res = await editInfo(params);
          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: `${text}成功!`
            });
            this.getTableInfo();
          } else {
            this.$message({
              type: "warn",
              message: `${text}失败!`
            });
            this.getTableInfo();
          }
        })
        .catch(() => {
          row.publish = row.publish == 1 ? 0 : 1;
        });
    },

    openForm(type, id = null) {
      this.$refs.dialogFormRef.open(type, id);
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.getTableInfo();
    },
    getTableInfo() {
      this.loading = true;
      // const params = tansParams(this.queryForm);
      if (this.dateRange && this.dateRange.length > 0) {
        this.queryForm.startTime = this.dateRange[0] + " 00:00:00";
        this.queryForm.endTime = this.dateRange[1] + " 23:59:59";
      }
      getList(this.queryForm).then(res => {
        this.tableData = res.data.data.rows;
        this.totalCount = res.data.data.total;
        this.loading = false;
      });
    },
    // 试题保存回调
    bucketSave() {
      this.$refs.questionDialogRef.close();
      this.getTableInfo();
    },
    // 清空试题
    clearBucket() {
      this.$refs.questionDialogRef.setBucket([]);
    },
    setScore(data) {
      this.$refs.bucketDialogRef.setScore(data);
      this.$refs.questionDialogRef.setBucket(
        Object.values(data).flatMap(item => item.data)
      );
    },
    // 关联试题
    async contact(val) {
      this.$refs.questionDialogRef.open(val);
    },
    // 打开试题篮
    async handleClick(item) {
      this.$refs.bucketDialogRef.open(false, item);
    },
    // 打开试题篮
    openBucket(row, data) {
      this.$refs.bucketDialogRef.open(true, row, data);
    },
    openScore(paper, data) {
      console.log(paper, data);
      this.$refs.scoreDialogRef.open(paper, data);
    },
    async removeClick(id) {
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await deleteInfo(id);

          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getTableInfo();
          }
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.getTableInfo();
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Paper/HandsOn/index.vue